import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HFOptionGroup from 'components/HFInputs/HFOptionGroup'
import HFDropdown from 'components/HFInputs/HFDropdown'
import HFTextInput from 'components/HFInputs/HFTextInput'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import {
	booleanOptions,
	booleanSuccessfulContactOptions,
	motiveOptions,
} from 'controllers/TaskManager/formOptions'

import { useFormContext } from 'react-hook-form'

import styles from '../../controllers/Dialog.module.sass'

export const ForwardingContactController = ({ showJustification = false }) => {
	const { i18n } = useGlobal()
	const { watch } = useFormContext()

	const [contactVictim, contactFailedReason] = watch([
		'contact.contactVictim',
		'contact.contactFailedReason',
	])

	return (
		<>
			<fieldset>
				<VStack>
					<h5>{i18n`Do you wish to contact the victim?`}</h5>
					<VStack gap='xsmall'>
						<HFOptionGroup
							className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
							name='contact.contactVictim'
							type='boolean'
							options={booleanOptions}
						/>

						{contactVictim === true && (
							<VStack className={styles['form-input']}>
								<h5>{i18n`Was the contact attempt successful?`}</h5>
								<HFOptionGroup
									className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
									name='contact.successfulContact'
									options={booleanSuccessfulContactOptions}
								/>
							</VStack>
						)}

						{/* No-information origin: declining to contact requires a
						    justification (why the victim is not being contacted). */}
						{showJustification && contactVictim === false && (
							<VStack gap='xsmall'>
								<VStack className={styles['form-input']}>
									<h5>{i18n`Reason`}</h5>
									<HFDropdown
										name='contact.contactFailedReason'
										options={motiveOptions || []}
										optionsAlign='right'
										searchable={true}
										noData={i18n`No results`}
									/>
								</VStack>

								{contactFailedReason === 4 && (
									<VStack className={styles['form-input']}>
										<h5>{i18n`Description`}</h5>
										<HFTextInput
											name='contact.contactFailedOtherReason'
											multiline={false}
											rows={5}
											noResize
										/>
									</VStack>
								)}
							</VStack>
						)}
					</VStack>
				</VStack>
			</fieldset>
		</>
	)
}
